import React from 'react';
import { FootprintsIcon, LayoutGridIcon, MegaphoneIcon, SlidersHorizontalIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { GuidePagePreview } from '../GuidePagePreview';
import { guidePages } from '../../data/activities';
import { proofCaptions } from '../../data/salesContent';
const captionIcons = [LayoutGridIcon, FootprintsIcon, MegaphoneIcon, SlidersHorizontalIcon];
export function VisualProofSection() {
  return <section className="border-t border-line bg-navy py-8 sm:py-12" aria-labelledby="proof-title" data-id="element-197" data-mp="3i7rs73p3rdhg">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-198" data-mp="3dcvq1aq5j9qm">
        <div id="proof-title" data-id="element-199" data-mp="38gx2tqgk7xrs">
          <SectionHeading title="See What Your Next Halloween PE Class Could Look Like" subtitle="Clear setups. Visual instructions. Less explaining. More movement." data-id="element-200" data-mp="38g5b4qq32k6s" />
        </div>

        <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-201" data-mp="2yjin5t2gnd0j">
          {proofCaptions.map((c, i) => {
          const Icon = captionIcons[i];
          return <li key={c.title} title={c.text} className="flex items-center gap-1.5 rounded-full border border-line bg-night px-3 py-1.5 font-display text-[12px] font-extrabold uppercase tracking-wide text-cream" data-id="element-202" data-mp="3jnkq15hdpg9t" data-mpi={i}>
                <Icon className="h-3.5 w-3.5 shrink-0 text-pumpkin" aria-hidden="true" data-id="element-203" data-mp="3equ7mbi3q8l8" />
                {c.title}
              </li>;
        })}
        </ul>

        <div className="mt-5 flex w-full snap-x snap-mandatory gap-3 overflow-x-auto overscroll-x-contain pb-3 sm:grid sm:grid-cols-2 sm:gap-5 sm:overflow-visible sm:pb-0 lg:grid-cols-4" data-id="element-204" data-mp="b9lvm8a222yf">
          {guidePages.map(page => <div key={page.title} className="w-[84%] min-w-0 shrink-0 snap-start sm:w-auto" data-id="element-205" data-mp="19l8eb92f2oy">
              <GuidePagePreview page={page} data-id="element-206" data-mp="2hygwzo8usxll" />
            </div>)}
        </div>
        <p className="mt-3 text-center text-xs text-muted sm:hidden" data-id="element-207" data-mp="2m1dkntd93jwe">Swipe to see more pages →</p>
      </div>
    </section>;
}